<template>
    <LayoutAdmin>
        <div class="main-content">
            <section class="section">
                <div class="section-header">
                    <h1>Pesanan</h1>
                </div>

                <div class="section-body">
                    <!-- filter -->

                    <!-- list pesanan -->
                    <div class="mt-3">
                        <div
                            v-for="pes in pesanan"
                            :key="'pes-'+pes.id_pesanan"
                            class="card p-3 mb-0"
                            style="border:1px solid #e3eaef;"
                        >
                            <div style="position: relative">
                                <table>
                                    <tr>
                                        <td class="p-1">Pemesan</td>
                                        <td class="p-1">:</td>
                                        <td class="p-1"><b>{{ pes.data_permohonan.penduduk.nama_lengkap }}</b></td>
                                    </tr>
                                    <tr>
                                        <td class="p-1">Perkiraan Waktu Ambil</td>
                                        <td class="p-1">:</td>
                                        <td class="p-1">
                                            <b>
                                            {{ new Date(pes.data_permohonan.waktu_ke_dari_angkringan).toLocaleDateString('id-ID', {year: 'numeric', month: 'short', day: 'numeric'}) + ' ' + pes.data_permohonan.waktu_ke_dari_angkringan.substr(11, 8) }}
                                            </b>
                                        </td>
                                    </tr>
                                </table>
                                <span
                                    class="badge"
                                    :class="(pes.data_permohonan.status === 16) ? 'badge-success' : (pes.data_permohonan.status === 15) ? 'badge-warning' : '' "
                                    style="position: absolute; right: 0; top: 0"
                                >
                                    <i 
                                        class="fa mr-2"
                                        :class="(pes.data_permohonan.status === 16) ? 'fa-check' : (pes.data_permohonan.status === 15) ? 'fa-info-circle' : ''"
                                    />
                                    {{ (pes.data_permohonan.status === 16) ? 'Selesai' : (pes.data_permohonan.status === 15) ? 'Belum Diproses' : '' }}
                                </span>
                            </div>
                            <div>
                                <table class="table table-sm">
                                    <tr
                                        v-for="p in pes.det_pesanan"
                                        :key="p.id_det_pesanan"
                                    >
                                        <td>
                                            <img v-if="!p.menu_umkm.foto" class="card-img-top" :src="require('./../../assets/stisla/img/news/img01.jpg')" style="width: 30px">
                                            <img v-else :src="$store.getters.getBaseUrl + '/api/file/' + p.menu_umkm.foto" style="width: 30px">
                                            <span class="pl-3">{{ p.menu_umkm.nama_menu }}</span>
                                        </td>
                                        <td>
                                            Rp {{ p.harga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
                                        </td>
                                        <td>
                                            Jumlah:
                                            {{ p.jumlah }}
                                        </td>
                                        <td>
                                            <b>Rp {{ (p.jumlah * p.harga).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" class="text-right">
                                            <span class="font-weight-bold" style="font-size: 1.2rem">Total</span>
                                        </td>
                                        <td>
                                            <span class="font-weight-bold" style="font-size: 1.2rem">Rp {{ (pes.total).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</span>
                                        </td>
                                    </tr>
                                </table>
                                <!-- <div
                                    v-for="p in pes.det_pesanan"
                                    :key="p.id_det_pesanan"
                                >
                                    <div class="row">
                                        <div>
                                            <img v-if="!p.menu_umkm.foto" class="card-img-top" :src="require('./../../assets/stisla/img/news/img01.jpg')" style="width: 30px">
                                            <img v-else :src="$store.getters.getBaseUrl + '/api/file/' + p.menu_umkm.foto" style="width: 30px">
                                        </div>
                                        <div class="col">
                                            <b>{{ p.menu_umkm.nama_menu }}</b>
                                        </div>
                                        <div class="col">
                                            <p class="text-right">Rp {{ p.harga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</p>
                                        </div>
                                        <div class="col">
                                            <b>Jumlah:</b>
                                            {{ p.jumlah }}
                                        </div>
                                        <div class="col">
                                            <b>Rp {{ (p.jumlah * p.harga).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</b>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
  </LayoutAdmin>
</template>

<script>
import LayoutAdmin from './../layouts/Admin.vue'

export default {
	components: {
		LayoutAdmin
	},
    data () {
        return {
            pesanan: []
        }
    },
    mounted () {
        this.loadPesanan()
    },
    methods: {
        loadPesanan () {
            let filter = {
                data: true
            }
            this.$store.dispatch('fetchPesanan', filter).then((res) => {
                if (res.data.status) {
                    this.pesanan = res.data.data
                } else {
                    //
                }
            })
                .catch(() => {
                    //
                })
        }
    }
}
</script>